import OptionTitle from './OptionTitle';
import CurrencyIcon from '../../MobileGameView/CurrencyIcon';
import Translation from '@/client/components/Translation';
import BottomSheet from '@/external/components/BottomSheet';
import MenuItem from '@/external/components/MenuItem';

type Props = {
  isOpened: boolean;
  onClose: () => void;
  optionsList: {
    name: string;
    value: string | null;
    selected?: boolean;
  }[];
  translations: Record<string, string>;
  onSelect: (value: string) => void;
};

const GameCurrencyOptions: FC<Props> = ({
  isOpened,
  optionsList,
  onClose,
  translations,
  onSelect,
}) => {
  const selectCurrency = (value: string | null) => {
    onSelect(value ?? '');
    onClose();
  };

  return (
    <BottomSheet rootId="default-layout" open={isOpened} onClose={onClose}>
      <BottomSheet.Backdrop />
      <BottomSheet.Panel className="h-auto p-0 pt-3" onClose={onClose}>
        <BottomSheet.Draghandle />
        <BottomSheet.Title className="p-3 text-moon-18">
          <Translation
            id="casino.in_game_currency"
            translations={translations}
          />
        </BottomSheet.Title>
        <div className="flex flex-col gap-2 p-4 px-2 pb-3">
          {optionsList.map(({ name, value, selected }) => (
            <MenuItem
              isSelected={selected}
              key={value}
              className="px-2 py-3"
              onClick={() => selectCurrency(value)}
            >
              <CurrencyIcon currency={name} size="lg" />
              <MenuItem.Title>
                <OptionTitle name={name} translations={translations} />
              </MenuItem.Title>
              <MenuItem.Radio />
            </MenuItem>
          ))}
        </div>
      </BottomSheet.Panel>
    </BottomSheet>
  );
};

export default GameCurrencyOptions;
